import { Box, Button, HStack, Heading, Text } from '@chakra-ui/react';
import { IDealer } from 'interfaces/dealer.interface';
import Link from 'next/link';

type AgentItemProps = {
  dealer: IDealer;
  onClick: () => void;
};

function AgentItem({ dealer, onClick }: AgentItemProps) {
  return (
    <Box mb={2} pb={2} borderBottom="1px solid #999">
      <HStack justifyContent="space-between" alignItems="flex-end">
        <Box>
          <Heading
            as="h2"
            fontSize="md"
            fontWeight={400}
            mb={1}
            onClick={onClick}
            cursor={'pointer'}
            _hover={{
              color: 'primary.500',
            }}
          >
            {dealer.name}
          </Heading>
          <Text fontSize="14px" lineHeight={1.3}>
            {dealer.address} {dealer.subDistrict} {dealer.district}{' '}
            {dealer.province ? dealer.province.name_th : 'NA'}{' '}
            {dealer.postalCode}
          </Text>
          <Text fontSize="14px" lineHeight={1.3}>
            โทร: {dealer.phone}
          </Text>
        </Box>
        <Box>
          <Button
            variant="link"
            size="sm"
            onClick={() => {
              window.open(
                `https://www.google.com/maps/dir/?api=1&destination=${dealer.latitude},${dealer.longitude}`,
                '_blank'
              );
            }}
          >
            นำทาง
          </Button>
        </Box>
      </HStack>
      {dealer.externalUrl && (
        <Box mt={-1}>
          <Button
            variant="link"
            size="sm"
            fontWeight={300}
            onClick={() => {
              window.open(dealer.externalUrl?.toString()!, '_blank');
            }}
          >
            {dealer.externalUrl}
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default AgentItem;
